/* RESPONSIBLE TEAM: team-automation-foundations */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import type Transition from '@ember/routing/transition';

export default class LegacyAskIndexRoute extends Route {
  @service declare router: RouterService;

  beforeModel(transition: Transition) {
    let queryParams = transition.to?.queryParams ?? {};
    this.router.replaceWith('apps.app.automation.fin-ai-agent.operator', { queryParams });
  }
}
